var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "block docx-file-block is-in-video-v2",
      class: `item-${_vm.children.blockId}`,
    },
    [
      _vm.showFileDIv
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { attrs: { contenteditable: "false" } }, [
              _vm.showFileMP4
                ? _c(
                    "div",
                    {
                      staticClass:
                        "docx-file-block-container docx-view-type-Preview",
                    },
                    [
                      _c("div", { staticClass: "preview-card-header" }, [
                        _c("div", {
                          staticClass:
                            "preview-card-header__mask preview-card-header__mask-video",
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "preview-card-header__container" },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "18",
                                  height: "18",
                                  viewBox: "0 0 32 32",
                                },
                              },
                              [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      d: "M1.5 0h14.086a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V26.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 26.5v-25A1.5 1.5 0 011.5 0z",
                                      id: "icon_file_video_nor_svg__a",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M16.293.293l5.414 5.414A1 1 0 0121.91 6H17.5A1.5 1.5 0 0116 4.5V.09a1 1 0 01.293.203z",
                                      id: "icon_file_video_nor_svg__b",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      fill: "none",
                                      "fill-rule": "evenodd",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: { transform: "translate(5 2)" },
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            fill: "#3370FF",
                                            "xlink:href":
                                              "#icon_file_video_nor_svg__a",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("use", {
                                          attrs: {
                                            fill: "#245BDB",
                                            "xlink:href":
                                              "#icon_file_video_nor_svg__b",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: { d: "M7 11h16.649v16.649H7z" },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M10.757 15h7.486c.383 0 .7.285.75.654l.007.103v7.486c0 .383-.285.7-.654.75l-.103.007h-7.486a.757.757 0 01-.75-.654L10 23.243v-7.486c0-.383.285-.7.654-.75l.103-.007h7.486zm11.819 1.792a.568.568 0 01.075.282v4.854a.568.568 0 01-.85.493l-1.799-1.028v-3.784l1.8-1.028a.568.568 0 01.774.211zM13.1 16.5h-1.2a.4.4 0 00-.4.4v1.2c0 .22.18.4.4.4h1.2a.4.4 0 00.4-.4v-1.2a.4.4 0 00-.4-.4z",
                                        fill: "#FFF",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "preview-card-header__container-title",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.children.blockAttr.file.name.slice(
                                      0,
                                      -4
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "video-content" }, [
                        _vm.errorText
                          ? _c("div", { staticClass: "error-mask" }, [
                              _vm._v(_vm._s(_vm.errorText)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("video", {
                          attrs: {
                            controls: "",
                            playsinline: "true",
                            "x5-playsinline": "true",
                            "webkit-playsinline": "true",
                            mediatype: "video",
                            "data-index": "-1",
                            id: `video-${_vm.children.blockId}`,
                            src: _vm.videoUrl,
                          },
                          on: { error: _vm.videoError },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showFilePDF
                ? _c(
                    "div",
                    {
                      staticClass:
                        "docx-file-block-container docx-view-type-Card",
                    },
                    [
                      _c("div", { staticClass: "file-block file-card" }, [
                        _c("div", { staticClass: "layout-column file-icon" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "48",
                                height: "48",
                                viewBox: "0 0 32 32",
                              },
                            },
                            [
                              _c("defs", [
                                _c("path", {
                                  attrs: {
                                    d: "M1.5 0h14.086a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V26.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 26.5v-25A1.5 1.5 0 011.5 0z",
                                    id: "icon_file_pdf_nor_svg__a",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M16.293.293l5.414 5.414A1 1 0 0121.91 6H17.5A1.5 1.5 0 0116 4.5V.09a1 1 0 01.293.203z",
                                    id: "icon_file_pdf_nor_svg__b",
                                  },
                                }),
                              ]),
                              _c(
                                "g",
                                {
                                  attrs: {
                                    fill: "none",
                                    "fill-rule": "evenodd",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    { attrs: { transform: "translate(5 2)" } },
                                    [
                                      _c("use", {
                                        attrs: {
                                          fill: "#F54A45",
                                          "xlink:href":
                                            "#icon_file_pdf_nor_svg__a",
                                        },
                                      }),
                                      _c("use", {
                                        attrs: {
                                          fill: "#D83931",
                                          "xlink:href":
                                            "#icon_file_pdf_nor_svg__b",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c("path", {
                                    attrs: {
                                      d: "M7.649 10.703h16.648V27.35H7.65z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M23.674 21.179c-.344-.403-1.05-.6-2.158-.6-.645 0-1.532.017-2.424.15-2.436-1.757-3.007-3.643-3.007-3.643s.416-1.044.443-2.75c.017-1.078-.154-1.882-.59-2.228a1.224 1.224 0 00-.727-.27.971.971 0 00-.573.178c-1.266.914.117 5.22.154 5.336a38.289 38.289 0 01-2.126 4.336c-.251.438-.251.447-.42.646 0 0-2.217 1.1-3.256 2.318-.588.689-.607 1.162-.576 1.516.05.425.592.805 1.138.805.022 0 .045 0 .067-.002.555-.034 1.171-.186 1.857-.835.497-.47 1.056-1.746 1.774-2.995 2.06-.577 3.873-.989 5.392-1.224 1.114.592 2.772 1.261 3.9 1.261.38 0 .684-.076.906-.226.265-.18.378-.403.448-.817.07-.414-.027-.728-.222-.956zm-2.422.648c1.03 0 1.586.182 1.872.334.089.047.153.092.198.13-.08.062-.239.141-.526.141-.475 0-1.099-.201-1.86-.6.108-.003.214-.005.316-.005zm-5.91-9.077a.09.09 0 01.003-.004c.16.118.235.95.22 1.43-.02.647-.025.897-.106 1.294-.22-.828-.236-2.316-.116-2.72zm.052 6.05c.502.827 1.138 1.664 1.855 2.303-1.4.3-2.562.575-3.398.868a25.868 25.868 0 001.543-3.171zm-5.651 7.003c.127-.187.473-.55 1.35-1.252-.471 1.085-1 1.252-1.491 1.514.037-.086.083-.176.14-.262z",
                                      fill: "#FFF",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "layout-column layout-main-center flex-1",
                          },
                          [
                            _c("div", { staticClass: "file-name" }, [
                              _vm._v(_vm._s(_vm.fileName)),
                            ]),
                            _vm._v(" "),
                            _vm._m(1),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "layout-row file-btn" }, [
                          _c(
                            "div",
                            {
                              staticClass: "btn-preview tooltip-host",
                              on: { click: _vm.download },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "universe-icon media-preview-icon",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "1em",
                                        height: "1em",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "data-icon": "DownloadOutlined",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M20 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14v-1a1 1 0 0 1 1-1Zm-7-3.964 2.657-2.657a1 1 0 0 1 1.414 1.414c-1.414 1.415-2.828 2.83-4.244 4.244a1 1 0 0 1-1.412 0c-1.417-1.415-2.833-2.833-4.249-4.25a.993.993 0 0 1 .013-1.401.992.992 0 0 1 1.401-.013l2.42 2.42V3.5a1 1 0 1 1 2 0v10.536Z",
                                          fill: "currentColor",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showFileZIP
                ? _c("div", { staticClass: "docx-file-block-container" }, [
                    _c("div", { staticClass: "file-block file-card" }, [
                      _c("div", { staticClass: "layout-column file-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "48",
                              height: "48",
                              viewBox: "0 0 32 32",
                            },
                          },
                          [
                            _c("defs", [
                              _c("path", {
                                attrs: {
                                  d: "M1.5 0h14.086a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V26.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 26.5v-25A1.5 1.5 0 011.5 0z",
                                  id: "icon_file_zip_nor_svg__a",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M16.293.293l5.414 5.414A1 1 0 0121.91 6H17.5A1.5 1.5 0 0116 4.5V.09a1 1 0 01.293.203z",
                                  id: "icon_file_zip_nor_svg__b",
                                },
                              }),
                            ]),
                            _c(
                              "g",
                              {
                                attrs: { fill: "none", "fill-rule": "evenodd" },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(5 2)" } },
                                  [
                                    _c("use", {
                                      attrs: {
                                        fill: "#3370FF",
                                        "xlink:href":
                                          "#icon_file_zip_nor_svg__a",
                                      },
                                    }),
                                    _c("use", {
                                      attrs: {
                                        fill: "#245BDB",
                                        "xlink:href":
                                          "#icon_file_zip_nor_svg__b",
                                      },
                                    }),
                                  ]
                                ),
                                _c("path", {
                                  attrs: { d: "M8 11h16.649v16.649H8z" },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M20 13a1 1 0 011 1v10a1 1 0 01-1 1h-8a1 1 0 01-1-1V14a1 1 0 011-1h8zm-2.7 5.5h-1.1a.2.2 0 00-.2.2v1.1c0 .11.09.2.2.2h1.1a.2.2 0 00.2-.2v-1.1a.2.2 0 00-.2-.2zM15.8 17h-1.1a.2.2 0 00-.193.147l-.007.053v1.1a.2.2 0 00.147.193l.053.007h1.1a.2.2 0 00.193-.147L16 18.3v-1.1a.2.2 0 00-.2-.2zm1.5-1.5h-1.1a.2.2 0 00-.193.147L16 15.7v1.1a.2.2 0 00.147.193L16.2 17h1.1a.2.2 0 00.193-.147l.007-.053v-1.1a.2.2 0 00-.2-.2zM15.8 14h-1.1a.2.2 0 00-.193.147l-.007.053v1.1a.2.2 0 00.147.193l.053.007h1.1a.2.2 0 00.193-.147L16 15.3v-1.1a.2.2 0 00-.2-.2zm-1.6 7h3.6c.11 0 .2.09.2.2v2.6a.2.2 0 01-.2.2h-3.6a.2.2 0 01-.2-.2v-2.6c0-.11.09-.2.2-.2zm.8 2h2v-1h-2v1z",
                                    fill: "#FFF",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "layout-column layout-main-center flex-1",
                        },
                        [
                          _c("div", { staticClass: "file-name" }, [
                            _vm._v(_vm._s(_vm.fileName)),
                          ]),
                          _vm._v(" "),
                          _vm._m(2),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "layout-row file-btn" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn-preview tooltip-host",
                            on: { click: _vm.download },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "universe-icon media-preview-icon",
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "1em",
                                      height: "1em",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "data-icon": "DownloadOutlined",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M20 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14v-1a1 1 0 0 1 1-1Zm-7-3.964 2.657-2.657a1 1 0 0 1 1.414 1.414c-1.414 1.415-2.828 2.83-4.244 4.244a1 1 0 0 1-1.412 0c-1.417-1.415-2.833-2.833-4.249-4.25a.993.993 0 0 1 .013-1.401.992.992 0 0 1 1.401-.013l2.42 2.42V3.5a1 1 0 1 1 2 0v10.536Z",
                                        fill: "currentColor",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm._m(3),
          ]
        : _c("div", { staticClass: "error-video-tip" }, [
            _c("p", [
              _vm._v(
                "视频【" +
                  _vm._s(_vm.fileName) +
                  "】格式为【" +
                  _vm._s(_vm.fileName.split(".")[1]) +
                  "】"
              ),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "请回到原飞书文档地址，下载视频文件，转码为【mp4】格式后重新上传视频  "
              ),
            ]),
          ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "docx-block-zero-space" }, [
      _c("span", { attrs: { "data-zero-space": "true" } }, [_vm._v("​")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "file-desc" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "file-desc" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "docx-block-zero-space" }, [
      _c("span", { attrs: { "data-zero-space": "true" } }, [_vm._v("​")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }